import type { ReactNode } from "react";

import { Sparkline } from "./Sparkline";

import "./ui.css";

interface StatTileProps {
  label: ReactNode;
  value: ReactNode;
  unit?: ReactNode;
  sub?: ReactNode;
  delta?: number | null;
  trend?: number[];
  tone?: "neutral" | "inverse";
  icon?: ReactNode;
}

export function StatTile({
  label,
  value,
  unit,
  sub,
  delta,
  trend,
  tone = "neutral",
  icon,
}: StatTileProps) {
  let deltaTone: "up" | "down" | "flat" | null = null;
  if (delta != null) {
    if (delta > 0) deltaTone = tone === "inverse" ? "down" : "up";
    else if (delta < 0) deltaTone = tone === "inverse" ? "up" : "down";
    else deltaTone = "flat";
  }
  const deltaSign = delta != null && delta > 0 ? "+" : "";

  return (
    <div className="stat-tile">
      <div className="stat-tile__top">
        <div className="stat-tile__label">{label}</div>
        {icon && <span className="stat-tile__icon">{icon}</span>}
      </div>
      <div className="stat-tile__value">
        <span>{value}</span>
        {unit && <span className="stat-tile__value-unit">{unit}</span>}
      </div>
      <div className="stat-tile__bottom">
        {deltaTone && delta != null && (
          <span className={`stat-tile__delta stat-tile__delta--${deltaTone}`}>
            <span aria-hidden="true">
              {deltaTone === "up" ? "↑" : deltaTone === "down" ? "↓" : "·"}
            </span>
            {deltaSign}
            {Math.abs(delta).toFixed(1)}%
          </span>
        )}
        {sub && <span className="stat-tile__sub">{sub}</span>}
        {trend && <Sparkline values={trend} className="stat-tile__spark" />}
      </div>
    </div>
  );
}
